"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "wf-component" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = ["value"];
const _hoisted_4 = { class: "ares-global-parameter-option" };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = ["value"];
const _hoisted_7 = { class: "ares-global-parameter-option" };
const _hoisted_8 = { key: 2 };
const _hoisted_9 = ["value"];
const _hoisted_10 = { class: "ares-global-parameter-option" };
const _hoisted_11 = { key: 3 };
const _hoisted_12 = ["value"];
const _hoisted_13 = { class: "ares-global-parameter-option" };
const _hoisted_14 = {
    key: 4,
    class: "nofloat"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.hazardData.erosionOceanCount.available)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[5] || (_cache[5] = [
                        (0, vue_1.createTextVNode)("Reveal erosions at:", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                _cache[7] || (_cache[7] = (0, vue_1.createTextVNode)("  ", -1)),
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.ADJUSTMENT_RANGE, (value) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", {
                        class: "form-radio form-inline ares-global-parameter-label",
                        key: value
                    }, [
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "radio",
                            value: value,
                            name: "lowOceanDelta",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.lowOceanDelta) = $event))
                        }, null, 8, _hoisted_3), [
                            [vue_1.vModelRadio, _ctx.lowOceanDelta]
                        ]),
                        _cache[6] || (_cache[6] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_4, [
                            (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(value + _ctx.hazardData.erosionOceanCount.threshold) + " oceans", 1)
                        ])), [
                            [_directive_i18n]
                        ])
                    ]));
                }), 128))
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.hazardData.removeDustStormsOceanCount.available)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_5, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[8] || (_cache[8] = [
                        (0, vue_1.createTextVNode)("Remove dust storms at:", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                _cache[10] || (_cache[10] = (0, vue_1.createTextVNode)("  ", -1)),
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.ADJUSTMENT_RANGE, (value) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", {
                        class: "form-radio form-inline ares-global-parameter-label",
                        key: value
                    }, [
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "radio",
                            value: value,
                            name: "highOceanDelta",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.highOceanDelta) = $event))
                        }, null, 8, _hoisted_6), [
                            [vue_1.vModelRadio, _ctx.highOceanDelta]
                        ]),
                        _cache[9] || (_cache[9] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_7, [
                            (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(value + _ctx.hazardData.removeDustStormsOceanCount.threshold) + " oceans", 1)
                        ])), [
                            [_directive_i18n]
                        ])
                    ]));
                }), 128))
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.hazardData.severeErosionTemperature.available)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_8, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[11] || (_cache[11] = [
                        (0, vue_1.createTextVNode)("Amplify erosions at:", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                _cache[13] || (_cache[13] = (0, vue_1.createTextVNode)("  ", -1)),
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.ADJUSTMENT_RANGE, (value) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", {
                        class: "form-radio form-inline ares-global-parameter-label",
                        key: value
                    }, [
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "radio",
                            value: value,
                            name: "temperatureDelta",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.temperatureDelta) = $event))
                        }, null, 8, _hoisted_9), [
                            [vue_1.vModelRadio, _ctx.temperatureDelta]
                        ]),
                        _cache[12] || (_cache[12] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_10, [
                            (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)((2 * value) + _ctx.hazardData.severeErosionTemperature.threshold) + " °C", 1)
                        ])), [
                            [_directive_i18n]
                        ])
                    ]));
                }), 128))
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.hazardData.severeDustStormOxygen.available)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_11, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[14] || (_cache[14] = [
                        (0, vue_1.createTextVNode)("Amplify dust storms at:", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                _cache[16] || (_cache[16] = (0, vue_1.createTextVNode)("  ", -1)),
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.ADJUSTMENT_RANGE, (value) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", {
                        class: "form-radio form-inline ares-global-parameter-label",
                        key: value
                    }, [
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "radio",
                            value: value,
                            name: "oxygenDelta",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.oxygenDelta) = $event))
                        }, null, 8, _hoisted_12), [
                            [vue_1.vModelRadio, _ctx.oxygenDelta]
                        ]),
                        _cache[15] || (_cache[15] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_13, [
                            (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(value + _ctx.hazardData.severeDustStormOxygen.threshold) + "% oxygen", 1)
                        ])), [
                            [_directive_i18n]
                        ])
                    ]));
                }), 128))
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.showsave === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_14, [
                (0, vue_1.createElementVNode)("button", {
                    class: "btn btn-primary btn-submit",
                    onClick: _cache[4] || (_cache[4] =
                        (...args) => (_ctx.saveData && _ctx.saveData(...args)))
                }, (0, vue_1.toDisplayString)(_ctx.playerinput.buttonLabel), 1)
            ]))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
